// extracted by mini-css-extract-plugin
export default {"withdrawfunds":"WithdrawFunds_withdrawfunds__u6-8C","listitemtext":"WithdrawFunds_listitemtext__h2XLe","errtxt":"WithdrawFunds_errtxt__LfFUO"};